<div class=content>
    <div class="close-container">
        <button class="close" type="button" (click)="closeModal()">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.2899 2.27085C11.7518 1.80895 11.7518 1.06006 11.2899 0.59816L11.0382 0.346425C10.5763 -0.115475 9.82742 -0.115475 9.36552 0.346425L5.81818 3.89376L2.27085 0.346426C1.80895 -0.115474 1.06006 -0.115475 0.59816 0.346425L0.346425 0.59816C-0.115475 1.06006 -0.115475 1.80895 0.346425 2.27085L3.89376 5.81818L0.346426 9.36552C-0.115474 9.82742 -0.115475 10.5763 0.346425 11.0382L0.59816 11.2899C1.06006 11.7518 1.80895 11.7518 2.27085 11.2899L5.81818 7.74261L9.36552 11.2899C9.82742 11.7518 10.5763 11.7518 11.0382 11.2899L11.2899 11.0382C11.7518 10.5763 11.7518 9.82742 11.2899 9.36552L7.74261 5.81818L11.2899 2.27085Z"
                    fill="#DB272D" />
            </svg>
        </button>
    </div>

    <div class="form">
        <div class="left-side">
            <div class="info-container">
                <div class="spans-container">
                    <span> Rastreabilidade Ativa. </span>
                    <span> Controle Completo. </span>
                </div>
                <div class="topic">
                    <div class="image">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                            fill="#e4002b">
                            <path
                                d="m387-412 35-114-92-74h114l36-112 36 112h114l-93 74 35 114-92-71-93 71ZM240-40v-309q-38-42-59-96t-21-115q0-134 93-227t227-93q134 0 227 93t93 227q0 61-21 115t-59 96v309l-240-80-240 80Zm240-280q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70ZM320-159l160-41 160 41v-124q-35 20-75.5 31.5T480-240q-44 0-84.5-11.5T320-283v124Zm160-62Z" />
                        </svg>
                    </div>
                    <div class="description">
                        <span> Atenção Personalizada </span>
                        <!-- <p> Atendimentos customizados mediante às suas necessidades. </p> -->
                    </div>
                </div>
                <div class="topic">
                    <div class="image">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                            fill="#e4002b">
                            <path
                                d="m226-559 78 33q14-28 29-54t33-52l-56-11-84 84Zm142 83 114 113q42-16 90-49t90-75q70-70 109.5-155.5T806-800q-72-5-158 34.5T492-656q-42 42-75 90t-49 90Zm178-65q-23-23-23-56.5t23-56.5q23-23 57-23t57 23q23 23 23 56.5T660-541q-23 23-57 23t-57-23Zm19 321 84-84-11-56q-26 18-52 32.5T532-299l33 79Zm313-653q19 121-23.5 235.5T708-419l20 99q4 20-2 39t-20 33L538-80l-84-197-171-171-197-84 167-168q14-14 33.5-20t39.5-2l99 20q104-104 218-147t235-24ZM157-321q35-35 85.5-35.5T328-322q35 35 34.5 85.5T327-151q-25 25-83.5 43T82-76q14-103 32-161.5t43-83.5Zm57 56q-10 10-20 36.5T180-175q27-4 53.5-13.5T270-208q12-12 13-29t-11-29q-12-12-29-11.5T214-265Z" />
                        </svg>
                    </div>
                    <div class="description">
                        <span> Tempo de Resposta Ágil </span>
                        <!-- <p> Solicitações atendidas em menos de 72 horas. </p> -->
                    </div>
                </div>
                <div class="logo">
                    <img class="safetrace"  src="../../../../assets/landing-page/safetrace-logo.png" alt="SafeTrace">
                    <img class="safebeef" src="../../../../assets/landing-page/safebeef-logo.png" alt="SafeBeef">
                    <img class="qima" src="../../../assets/landing-page/qima-logo.svg" alt="Qima">
                </div>
            </div>
        </div>

        <div class="right-side">
            <div class="form-container">
                <h2> Envie-nos uma solicitação! </h2>

                <form [formGroup]="messageForm">
                    <div class="input-container">
                        <input [ngStyle]="{ border: messageForm.get('name')!.value!.length > 0 && messageForm.get('name')?.touched && !messageForm.get('name')?.valid ? '#e4002b solid 2px;' : 'border: #cccccc solid 2px;'}" type="text" name="name" formControlName="name" placeholder="Nome" minlength="2">
                        <span [ngStyle]="{ opacity: messageForm.get('name')!.value!.length > 0 && messageForm.get('name')?.touched && !messageForm.get('name')?.valid ? '1' : '0'}"> Campo inválido </span>
                    </div>

                    <div class="input-container">
                        <input [ngStyle]="{ border: messageForm.get('email')!.value!.length > 0 && messageForm.get('email')?.touched && !messageForm.get('email')?.valid ? '#e4002b solid 2px;' : 'border: #cccccc solid 2px;'}" type="text" name="email" formControlName="email" placeholder="E-mail">
                        <span [ngStyle]="{ opacity: messageForm.get('email')!.value!.length > 0 && messageForm.get('email')?.touched && !messageForm.get('email')?.valid ? '1' : '0'}"> Campo inválido </span>
                    </div>

                    <div class="input-container">
                        <input [ngStyle]="{ border: messageForm.get('numberPhone')!.value!.length > 0 && messageForm.get('numberPhone')?.touched && !messageForm.get('numberPhone')?.valid ? '#e4002b solid 2px;' : 'border: #cccccc solid 2px;'}" type="text" name="numberPhone" formControlName="numberPhone" placeholder="Contato" mask="(00) 0 0000-0000||(00) 0000-0000">
                        <span [ngStyle]="{ opacity: messageForm.get('numberPhone')!.value!.length > 0 && messageForm.get('numberPhone')?.touched && !messageForm.get('numberPhone')?.valid ? '1' : '0'}"> Campo inválido </span>
                    </div>

                    <div class="button-container">
                        <button (click)="sendMessage()"> Enviar </button>
                    </div>
                    
                </form>

                <div class="socials-container">
                    <a target="_blank" rel="noopener noreferrer" href="https://safetrace.com.br/"> <button> <img src="../../../../assets/landing-page/safetrace-logo.png" alt=""> safetrace.com.br </button> </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/safetrace.com.br/"> <button> <img src="../../../../assets/landing-page/instagram-social.png" alt=""> Safetrace S/A  </button> </a>
                </div>
            </div>
        </div>
    </div>

</div>

